var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflinebathroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 30.8125H6.125C4.6375 30.8125 3.5 29.5938 3.5 28C3.5 26.4062 4.6375 25.1875 6.125 25.1875H21.875C23.3625 25.1875 24.5 26.4062 24.5 28C24.5 29.5938 23.3625 30.8125 21.875 30.8125Z",
    fill: "#FD800B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13H10.5C8.05 13 6.125 15.0625 6.125 17.6875V23.3125H21.875V17.6875C21.875 15.0625 19.95 13 17.5 13ZM12.25 18.625H10.5C9.975 18.625 9.625 18.25 9.625 17.6875C9.625 17.125 9.975 16.75 10.5 16.75H12.25C12.775 16.75 13.125 17.125 13.125 17.6875C13.125 18.25 12.775 18.625 12.25 18.625Z",
    fill: "#FD800B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41.125C11.6375 41.125 9.44999 40.2812 7.61249 38.7812L6.99999 41.875C6.91249 42.1562 6.99999 42.4375 7.17499 42.625C7.34999 42.9063 7.61249 43 7.87499 43H20.125C20.3875 43 20.65 42.9063 20.825 42.625C21 42.4375 21.0875 42.1562 21 41.875L20.3875 38.875C18.55 40.2813 16.3625 41.125 14 41.125Z",
    fill: "#FD800B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 32.6875C6.825 36.5312 10.15 39.25 14 39.25C17.85 39.25 21.2625 36.5312 22.3125 32.6875H5.6875Z",
    fill: "#FD800B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflinebathroom);
export default __webpack_public_path__ + "static/media/offlinebathroom.9b93abb4657ae2c942c51dc489af02b5.svg";
export { ForwardRef as ReactComponent };